import FileBlobPreview from './FileBlobPreview';
export default FileBlobPreview;
